export const GET_PETITIONS_REQUEST = 'GET_MP_PETITIONS_REQUEST';
export const GET_PETITIONS_SUCCESS = 'GET_MP_PETITIONS_SUCCESS';
export const GET_PETITIONS_FAILED = 'GET_MP_PETITIONS_FAILED';
